import React, { useState, useContext } from 'react';
import { Offcanvas, Nav, Button, Container, Navbar } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FiMenu, FiUser, FiUsers, FiSettings, FiLogOut, FiHome, FiMail, FiList, FiSliders, FiActivity, FiMonitor, FiTablet, FiShield, FiCalendar } from 'react-icons/fi';
import { Can } from '../config/ability';
import { AbilityContext } from '../config/ability';
import { useAbility } from '@casl/react';

const SidebarMenu = () => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');
    const ability = useAbility(AbilityContext);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleLogout = () => {
        localStorage.clear();
        ability.update([]); // Clear abilities
        window.location.href = '/login';
    };

    if (!token) return null;

    return (
        <>
            <Navbar expand="lg" className="navbar-custom mb-0" fixed="top">
                <Container className="d-flex align-items-center">
                    <Navbar.Brand 
                        as={Link} 
                        to="/" 
                        className="m-0 d-flex align-items-center gap-2"
                    >
                        <img 
                            src="/logo_texto_lateral.png" 
                            alt="Confirma AI" 
                            height="40" 
                            className="d-inline-block align-top"
                        />
                    </Navbar.Brand>
                    
                    <Button variant="link" onClick={handleShow} className="ms-auto p-0" style={{ color: 'var(--color-contrast)' }}>
                        <FiMenu size={28} />
                    </Button>
                </Container>
            </Navbar>
            {/* Spacer for fixed navbar */}
            <div style={{ height: '76px' }}></div>

            <Offcanvas show={show} onHide={handleClose} placement="end" backdrop={true} scroll={true} className="sidebar-custom">
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title className="text-white fw-bold">Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <Can I="read" a="Dashboard">
                            <Nav.Link as={Link} to="/dashboard" onClick={handleClose} className="sidebar-link">
                                <FiHome /> Dashboard
                            </Nav.Link>
                        </Can>
                        
                        <Can I="read" a="Training">
                            <Nav.Link as={Link} to="/training-list" onClick={handleClose} className="sidebar-link">
                                <FiList /> Lista de treinamento
                            </Nav.Link>
                        </Can>

                        <Can I="read" a="Calendar">
                            <Nav.Link as={Link} to="/calendar" onClick={handleClose} className="sidebar-link">
                                <FiCalendar /> Calendário
                            </Nav.Link>
                        </Can>
                        
                        <Can I="manage" a="MyAccount">
                            <Nav.Link as={Link} to="/my-account" onClick={handleClose} className="sidebar-link">
                                <FiUser /> Minha Conta
                            </Nav.Link>
                        </Can>

                        {/* Gestão Section - Visible if can manage any of the sub-items */}
                        <Can I="read" a="User" passThrough>
                            {(allowed) => (allowed || ability.can('read', 'Participant') || ability.can('manage', 'Room') || ability.can('manage', 'Profile') || ability.can('manage', 'Tablet')) && (
                                <>
                                    <hr className="border-secondary opacity-50 my-3" />
                                    <div className="text-white-50 small mb-2 text-uppercase fw-bold px-3">Gestão</div>
                                    
                                    <Can I="read" a="User">
                                        <Nav.Link as={Link} to="/user-management" onClick={handleClose} className="sidebar-link">
                                            <FiSettings /> Gestão de Usuários
                                        </Nav.Link>
                                    </Can>
                                    
                                    <Can I="manage" a="Profile">
                                        <Nav.Link as={Link} to="/profiles" onClick={handleClose} className="sidebar-link">
                                            <FiShield /> Gestão de Perfis
                                        </Nav.Link>
                                    </Can>
                                    
                                    <Can I="read" a="Participant">
                                        <Nav.Link as={Link} to="/participant-management" onClick={handleClose} className="sidebar-link">
                                            <FiUsers /> Gestão de Participantes
                                        </Nav.Link>
                                    </Can>
                                    
                                    <Can I="manage" a="Room">
                                        <Nav.Link as={Link} to="/rooms" onClick={handleClose} className="sidebar-link">
                                            <FiMonitor /> Gestão de Salas
                                        </Nav.Link>
                                    </Can>

                                    <Can I="manage" a="Tablet">
                                        <Nav.Link as={Link} to="/tablet-mode" onClick={handleClose} className="sidebar-link">
                                            <FiTablet /> Modo Tablet
                                        </Nav.Link>
                                    </Can>

                                    <Can I="manage" a="EmailConfig">
                                        <Nav.Link as={Link} to="/email-config" onClick={handleClose} className="sidebar-link">
                                            <FiMail /> Configurar e-mail
                                        </Nav.Link>
                                    </Can>
                                    
                                    <Can I="manage" a="SystemConfig">
                                        <Nav.Link as={Link} to="/settings" onClick={handleClose} className="sidebar-link">
                                            <FiSliders /> Configurações
                                        </Nav.Link>
                                    </Can>
                                    
                                    <Can I="read" a="AuditLog">
                                        <Nav.Link as={Link} to="/audit-logs" onClick={handleClose} className="sidebar-link">
                                            <FiActivity /> Logs de Auditoria
                                        </Nav.Link>
                                    </Can>
                                </>
                            )}
                        </Can>

                        <hr className="border-secondary opacity-50 my-3" />
                        <Nav.Link onClick={handleLogout} className="sidebar-link text-warning">
                            <FiLogOut /> Sair
                        </Nav.Link>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default SidebarMenu;